import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3333 10.4166V9.58331C18.3333 9.4728 18.2894 9.36682 18.2113 9.28868C18.1332 9.21054 18.0272 9.16664 17.9167 9.16664H4.44167L8.15001 5.46665C8.18881 5.42863 8.21964 5.38325 8.24068 5.33316C8.26173 5.28308 8.27256 5.2293 8.27256 5.17498C8.27256 5.12065 8.26173 5.06688 8.24068 5.01679C8.21964 4.96671 8.18881 4.92133 8.15001 4.88331L7.55834 4.29165C7.5196 4.25259 7.47352 4.22159 7.42275 4.20044C7.37197 4.17929 7.31751 4.1684 7.26251 4.1684C7.2075 4.1684 7.15304 4.17929 7.10227 4.20044C7.05149 4.22159 7.00541 4.25259 6.96667 4.29165L1.85001 9.39998C1.73427 9.51808 1.66859 9.6763 1.66667 9.84165V10.1583C1.66682 10.324 1.73276 10.4829 1.85001 10.6L6.96667 15.7083C7.00541 15.7474 7.05149 15.7784 7.10227 15.7995C7.15304 15.8207 7.2075 15.8316 7.26251 15.8316C7.31751 15.8316 7.37197 15.8207 7.42275 15.7995C7.47352 15.7784 7.5196 15.7474 7.55834 15.7083L8.15001 15.125C8.18906 15.0862 8.22006 15.0402 8.24121 14.9894C8.26236 14.9386 8.27325 14.8841 8.27325 14.8291C8.27325 14.7741 8.26236 14.7197 8.24121 14.6689C8.22006 14.6181 8.18906 14.572 8.15001 14.5333L4.44167 10.8333H17.9167C18.0272 10.8333 18.1332 10.7894 18.2113 10.7113C18.2894 10.6331 18.3333 10.5272 18.3333 10.4166Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgArrowLeft = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgArrowLeft;
